import { useState, useEffect } from 'react'
import hotkeys from 'hotkeys-js'

export function useCommandPalette() {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    // Bind Cmd+K (Mac) or Ctrl+K (Windows/Linux)
    const handler = function (event: KeyboardEvent, handler: hotkeys.HotkeysEvent) {
      event.preventDefault()
      setIsOpen((prev) => !prev)
    }
    
    hotkeys('cmd+k,ctrl+k', handler)

    // Cleanup on unmount
    return () => {
      hotkeys.unbind('cmd+k,ctrl+k', handler)
    }
  }, [])

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)
  const toggle = () => setIsOpen((prev) => !prev)

  return {
    isOpen,
    open,
    close,
    toggle,
  }
}

